
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FullscreenDialog.html?raw';
//import DataItems = require("DataItems");


class FullscreenDialog extends compose(_WidgetBaseSP) {
    templateString: any = template;

    modalContent: HTMLElement;
    headNode: HTMLElement;
    headerContentnode: HTMLElement;
    contentNode: HTMLElement;
    footerNode: HTMLElement;

    destroyOnClose: boolean = true;
    callback: Function = function () { };

    defaultUrl: string = null; // for the history manipulation
    dlgOpenUrl: string = "#FullscreenDialog_open";
    initialState: object; 
    onpopstateCallbackName: string = "_onpopstateCallback_fullscreenDialog";
    activeState: object = { name: "fullscreenDialogOpen", widgetID: "", };
    closedState: object = { name: "fullscreenDialogClosed", widgetID: ""};
    // der user hat sich mit vor- zurück und reload ausgetobt und wir wissen das initiale State nich - setzen wir eigenen
    customState: object = { name: "initialState_fullScreenDilog", widgetID: "" };

    _is_dlg_active: boolean = false;

    _isMobile: boolean = false;

    constructor(params?) {
        super(...(arguments as unknown as []));
        lang.mixin(this, params);
    }

    // events -----------------------------------------------------START

    // das hier ist generisch. 1x pro instanziierung aufgerufen. modifiziere this[this.activeState["onpopstateCallback"]]
    _onpopstateCallback_setup(evt?): void {

        if (this._isMobile === true) {
            // für jede instanz eigenen callback in die window property setzen // soll später vererbt werden
            if (history.state != null) {
                window.addEventListener("popstate", lang.hitch(this, this.onpopstateCallbackName));
                if (history.state["widgetID"] == this.id) {
                    this[this.onpopstateCallbackName]();
                }
            }
        } else {
            alert("start the widget in mobile version for the mobile version to work")
        }
    }

    // custom callback für diese instanz. bei jedem state kann man somit eigene callbacks registrieren. this._onpopstateCallback_setup() immer aufrufen
    _onpopstateCallback_fullscreenDialog(evt): void {

        if (this._isMobile === true) {
            if (history.state.name == this.initialState["name"] || history.state == null) {
                if (this._is_dlg_active === true) {
                    this.close();
                } else {
                    //
                }
            } else if (window["widgetsRoutingOrder"] && window["widgetsRoutingOrder"].length && window["widgetsRoutingOrder"].indexOf(this.id) == (window["widgetsRoutingOrder"].length - 1)) {
                // wenn das das oberste offene widget ist
                this.close();
            }
        } else {
            alert("start the widget in mobile version for the mobile version to work")
        }
    }

    _onClick_Close(): void {
        this.close();
    }

    // events -----------------------------------------------------END
    // content --------------------------------------------SSTART
    addNodeToContent(node): void{
        this.UiModder.domConstruct.place(node, this.contentNode, "last");
    }
    addContent(content: any): void {
        this.contentNode.innerHTML = this.contentNode.innerHTML + String(content);
    }
    clearContent(): void {
        this.contentNode.innerHTML = null;
    }

    addNodeToHeader(node): void {
        this.UiModder.domConstruct.place(node, this.headerContentnode, "last");
    }
    addHeaderContent(content: any): void {
        this.headerContentnode.innerHTML = this.headerContentnode.innerHTML + String(content);
    }
    clearHeaderContent(): void {
        this.headerContentnode.innerHTML = null;
    }

    addFooterToContent(node): void {
        this.UiModder.domConstruct.place(node, this.footerNode, "last");
    }
    addFooterContent(content: any): void {
        this.footerNode.innerHTML = this.footerNode.innerHTML + String(content);
    }
    clearFooterContent(): void {
        this.footerNode.innerHTML = null;
    }

    // content ------------------------------------END
    // state ---------------------------------------------------STaRT
    show(): void {
        if (this.domNode.parentNode == null) {
            this.placeAt(document.body);
        }

        this.UiModder.domStyle.set(this.domNode, "display", "block");


        if (this._isMobile === true) {
            // history stack
            if (history.state.name == this.activeState["name"] || history.state.name == this.closedState["name"]) {
                history.replaceState(this.activeState, "FullscreenDialog open", this.defaultUrl + this.dlgOpenUrl);
            } else {
                history.pushState(this.activeState, "FullscreenDialog open", this.defaultUrl + this.dlgOpenUrl);
            }
            if (window["widgetsRoutingOrder"].indexOf(this.id) == -1) {
                window["widgetsRoutingOrder"].push(this.id);
            }
        }
        

        this._is_dlg_active = true;
    }

    hide(): void {
        this.close();
    }

    close(result?): void {
        this.UiModder.domStyle.set(this.domNode, "display", "none");

        if (this._isMobile === true) {
            if (history.state["name"] != this.initialState["name"]) history.replaceState(this.closedState, "FullscreenDialog closed", this.defaultUrl);
            if (window["widgetsRoutingOrder"].indexOf(this.id) != -1) {
                window["widgetsRoutingOrder"].splice(window["widgetsRoutingOrder"].indexOf(this.id), 1);
            }
        }

        this.emit("closed", result);

        if (typeof (result) == "undefined") {
            result = 0;
        }

        //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
        // weitere Parameter zurückgeben, zB. Textinput?
        //
        setTimeout(lang.partial(this.callback, result), 1);

        if (this.destroyOnClose === true) {
            //  selbstzerstörung in 10 Sekunden :-) - etwas zeitverzögert falls noch irgendwas abgearbeitet werden muss das sich in einem verschachtelten widget befindet
            //
            setTimeout(lang.hitch(this, "destroy"), 10000);
        }
        this._is_dlg_active = false;
    }

    // state -------------------------------------------------------END
    // styles ------------------------------------------------------START

    // so kann mir kein Verrat vorgeworfen werden

    set_mds_styles(bool: boolean): void {
        // die von mir gesetzte w3-styles werden auf jeden Fall entfernt, die mds styles werden gesetzt oder entfernt je nach bool
        let trueAdd: Function = null;
        let trueRemove: Function = null;

        if (bool === false) {
            trueAdd = this.UiModder.domClass.remove;
            trueRemove = this.UiModder.domClass.add;
        } else {
            trueAdd = this.UiModder.domClass.add;
            trueRemove = this.UiModder.domClass.remove;
        }

        trueAdd(this.domNode, "FullscreenDialog");
        trueAdd(this.headNode, "header");

        this.UiModder.domClass.remove(this.domNode, "w3-modal");
        this.UiModder.domClass.remove(this.headNode, "w3-container");
        this.UiModder.domClass.remove(this.contentNode, "w3-container");
        this.UiModder.domClass.remove(this.footerNode, "w3-container");
        this.UiModder.domClass.remove(this.modalContent, "w3-modal-content");
    }
    set_w3_styles(bool: boolean): void {
        //  die mds styles werden auf jeden Fall entfernt, die von mir gesetzte w3-styles werden gesetzt oder entfernt je nach bool
        let trueAdd: Function = null;
        let trueRemove: Function = null;

        if (bool === false) {
            trueAdd = this.UiModder.domClass.remove;
            trueRemove = this.UiModder.domClass.add;
        } else {
            trueAdd = this.UiModder.domClass.add;
            trueRemove = this.UiModder.domClass.remove;
        }

        trueAdd(this.domNode, "w3-modal");
        trueAdd(this.headNode, "w3-container");
        trueAdd(this.contentNode, "w3-container");
        trueAdd(this.footerNode, "w3-container");
        trueAdd(this.modalContent, "w3-modal-content");

        this.UiModder.domClass.remove(this.domNode, "FullscreenDialog");
        this.UiModder.domClass.remove(this.headNode, "header");
    }

    // styles ------------------------------------------------------END
    // inherited ------------------------------------------------------------------
    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);
    }
    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        // touchscreen
        if ("ontouchstart" in document.documentElement) {
            this._isMobile = true;
        }

        if (this._isMobile === true) {
            if (!window["widgetsRoutingOrder"]) window["widgetsRoutingOrder"] = [];

            this.activeState["widgetID"] = this.id;
            this.closedState["widgetID"] = this.id;
            this.customState["widgetID"] = this.id;

            //urel bereinigen
            this.defaultUrl = document.location.href;
            let index: number = this.defaultUrl.indexOf(this.dlgOpenUrl);
            if (index != -1) this.defaultUrl = this.defaultUrl.slice(0, index);

            //initial state setzen:
            if (history.state != null && this.activeState["name"] != history.state["name"] && this.closedState["name"] != history.state["name"]) {
                this.initialState = history.state;
            } else {
                // der user hat sich mit vor- zurück und reload ausgetobt:
                this.initialState = this.customState;
                history.replaceState(this.initialState, "Dialog: Custom initial state", this.defaultUrl);
            }
            window.addEventListener("popstate", lang.hitch(this, "_onpopstateCallback_setup"));
            this._onpopstateCallback_setup();
        }
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

}

export default mdsWidget(FullscreenDialog);


